import { Grid, Paper } from '@mui/material';
import React from 'react';

export default function ProductReportLayout({ thumbnail, experience, composition }) {
  return (
    <Paper
      elevation={0}
      sx={{
        padding: { xs: 2, sm: 6 },
        margin: 0,
        minHeight: '100vh'
      }}
    >
      <Grid container spacing={2}>
        <Grid item container xs={12} spacing={2}>
          {thumbnail}
          {experience}
          {composition}
        </Grid>
      </Grid>
    </Paper>
  );
}
